// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__23Xkf","buttons":"SendReceipts_buttons__jFJBA","email":"SendReceipts_email__3E7ua","bookApptTitle":"SendReceipts_bookApptTitle__2SdKP"};